/** Options read only by `typeahead-employee` (kept out of dynamic.interface.ts, WI 35328). */
export interface IDynamicEmployeeOptions {
  /** One row per person from the HRRef-grouped employee dropdown; the value is `HRRef`. */
  distinctHRRef?: boolean;
  /**
   * WI 35328: one row per person (HRRef) from the lean picker endpoint, which returns no SSN,
   * Last4SSN, birth date, phone or pay field. The row's `Id` is still a payroll Employee id, so a
   * form that stores `valueProperty: 'Id'` keeps its stored values. Takes precedence over
   * `distinctHRRef`.
   */
  employeePicker?: boolean;
  /**
   * Bug 35871: the saved-value lookup skips the host's `customQueryParams` (e.g. `IsActive: true`), so a
   * saved employee who has since gone inactive still resolves. A typed search keeps them.
   */
  prefillSkipsCustomQueryParams?: boolean;
  /**
   * US 36258: the form control (e.g. `Company`) holding the Viewpoint company id. While it has a value
   * the search sends `favoriteVpCompanyID` with `favoriteType`, so that company's configured contacts come
   * back flagged `IsRecommended` and listed first (ahead of the user's favorites, which are kept). Exactly
   * one recommended contact pre-fills an EMPTY control on a new form (never on edit, never over a pick), and
   * a company change reloads the list. Absent = today's behavior.
   */
  favoriteCompanyFormControl?: string;
}
